import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-134e73d2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-top"
};
const _hoisted_2 = {
  class: "teacher-main-title"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-icon"
}, null, -1));

const _hoisted_4 = {
  class: "text"
};
import { CaretTop } from '@element-plus/icons-vue';
import { Sort } from '../index';
export default /*#__PURE__*/_defineComponent({
  props: {
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["updateSearch"],

  setup(__props, {
    emit
  }) {
    const option = reactive({
      keyword: '',
      sort_type: Sort.COMPREHENSIVE
    });
    const options = [{
      name: '综合排序',
      value: Sort.COMPREHENSIVE
    }, {
      name: '查看量从高到低',
      value: Sort.VIEWNUM
    }, {
      name: '更新时间倒序',
      value: Sort.UPDATETIME
    }, {
      name: '创建时间倒序',
      value: Sort.CREATTIME
    }];

    const handleSearch = () => {
      emit('updateSearch', option);
    };

    return (_ctx, _cache) => {
      const _component_ElOption = _resolveComponent("ElOption");

      const _component_ElSelect = _resolveComponent("ElSelect");

      const _component_ElInput = _resolveComponent("ElInput");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(__props.menuInfo.nav_name) + "  ", 1)]), _createVNode(_component_ElSelect, {
        modelValue: _unref(option).sort_type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(option).sort_type = $event),
        onChange: handleSearch,
        "suffix-icon": _unref(CaretTop)
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, item => {
          return _createVNode(_component_ElOption, {
            key: item.value,
            label: item.name,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue", "suffix-icon"]), _createVNode(_component_ElInput, {
        modelValue: _unref(option).keyword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(option).keyword = $event),
        size: "default",
        class: "search-input",
        onKeyup: _withKeys(handleSearch, ["enter"]),
        placeholder: "搜索关键词"
      }, {
        suffix: _withCtx(() => [_createElementVNode("i", {
          class: "iconfont icon-sousuo search-icon",
          onClick: handleSearch
        })]),
        _: 1
      }, 8, ["modelValue", "onKeyup"])]);
    };
  }

});